import React, { useState, useEffect } from 'react'
import { FormGroup, Button, HTMLSelect } from '@blueprintjs/core'
import qz from 'qz-tray'
import { useWebPortConveyor } from '../../contexts/ConveyorPortContext'

const ConveyorPortPicker = () => {
  const { port, isOpen, selectAndOpenPort, closePort } = useWebPortConveyor()
  const [ports, setPorts] = useState<string[]>([])

  useEffect(() => {
    // eslint-disable-next-line no-console
    qz.serial.findPorts().then(setPorts).catch(console.error)
  }, [])

  return (
    <div>
      <FormGroup label="Conveyor port">
        <HTMLSelect
          id="ports"
          options={[{ value: '', label: 'No port selected' }, ...ports.map(p => ({ value: p, label: p }))]}
          value={port || ''}
          onChange={e => selectAndOpenPort(e.target.value)}
        />
        <Button onClick={closePort} disabled={!isOpen} minimal icon="cross">
          Close Port
        </Button>
      </FormGroup>
    </div>
  )
}

export default ConveyorPortPicker
